"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.video = exports.videoInfo = void 0;

const videoInfo = () => ({
  position: 'absolute',
  bottom: 0,
  left: 0
});

exports.videoInfo = videoInfo;

const video = () => ({
  maxWidth: '100%'
});

exports.video = video;
//# sourceMappingURL=Video.styles.js.map